import React, { useEffect, useState } from 'react';
import styles from './SpeechAndTestimonialsPage.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import LoaderButton from '../../Molecules/Loader/LoaderButton';
import ApplicantsTab from '../../Atoms/Tabs/ApplicantsTab';
import speechIcon from '../../../assets/Imagess/speech.svg';
import testimonialIcon from '../../../assets/Imagess/testimonials.svg';
import TopHeader from '../../Molecules/SpeechAndTestimonials/TopHeader';
import { useFetchTestimonial } from '../../../Hooks/Testimonials';
import Testimonial from '../../Molecules/SpeechAndTestimonials/Testimonial';
import { debounce, isEmpty } from 'lodash';
import Loader from '../../Molecules/Loader/Loader';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';

const SpeechAndTestimonials = () => {
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(
    location?.state?.selected || 'speech'
  );
  const navigate = useNavigate();
  const tabs = [
    { index: 0, name: 'speech', text: 'خطاب', icon: speechIcon },
    {
      index: 1,
      name: 'testimonials',
      text: 'الشهادات',
      icon: testimonialIcon,
    },
  ];

  const { data, refetch, isLoading } = useFetchTestimonial(
    'speech' === selected ? false : true,
    search
  );

  useEffect(() => {
    if (!isEmpty(search)) {
      handleSearch();
    }
  }, [search]);

  const handleSearch = debounce(() => {
    refetch();
  }, 300);

  useEffect(() => {
    refetch();
  }, [selected]);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate(`/home/create-speech/${selected}`);
  };

  return (
    <div>
      <div className={styles['tab-container']}>
        {tabs.map((tab) => (
          <ApplicantsTab
            key={tab.index}
            text={tab.text}
            handleOnClick={() => {
              setSelected(tab.name);
            }}
            icon={tab.icon}
            active={tab.name === selected ? true : false}
            shadowed={false}
          />
        ))}
      </div>
      <TopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        buttonTitle={'speech' === selected ? 'خطاب جديد' : 'شهادة جديدة'}
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : data?.data?.length > 0 ? (
          <div className={styles['major-box-grid']}>
            {data?.data?.map((testimonial) => (
              <Testimonial
                testimonial={testimonial}
                refetch={refetch}
                key={testimonial?.testimonialId}
              />
            ))}
          </div>
        ) : (
          <NoDataComponent />
        )}
      </div>
    </div>
  );
};

export default SpeechAndTestimonials;
